import { type IssueTypeFields, type Stored } from "@overmap-ai/common"
import { selectAttachmentsOfIssueTypeFields } from "@overmap-ai/core"
import { FieldsRenderer } from "@overmap-ai/forms"
import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

import { sdk } from "../../sdk"
import { useShallowEqaulSelector } from "../../store"
import { draftCancelButtonProps, submitButtonProps } from "./constants"
import { useDeserializeFieldSchemaConfig, useFieldSchemaFromConfig, useHydrateFieldsWithAttachments } from "./hooks"

interface IssueTypeFieldsSubmitterProps extends Omit<
	ComponentProps<typeof FieldsRenderer>,
	"fieldSchema" | "cancelButtonProps" | "submitButtonProps"
> {
	issueTypeFields: Stored<IssueTypeFields>
}

export const IssueTypeFieldsSubmitter = memo<IssueTypeFieldsSubmitterProps>((props) => {
	const { className, issueTypeFields, ...rest } = props

	const attachments = useShallowEqaulSelector(selectAttachmentsOfIssueTypeFields(issueTypeFields.uuid))

	const fieldSchemaConfig = useDeserializeFieldSchemaConfig(issueTypeFields.fields)

	const fieldSchemaConfigWithImages = useHydrateFieldsWithAttachments(
		fieldSchemaConfig,
		attachments,
		sdk.issueTypeFieldsAttachments,
	)
	const fieldSchema = useFieldSchemaFromConfig(fieldSchemaConfigWithImages)

	return (
		<FieldsRenderer
			className={cx(className, "h-max w-full")}
			fieldSchema={fieldSchema}
			submitButtonProps={submitButtonProps}
			cancelButtonProps={draftCancelButtonProps}
			{...rest}
		/>
	)
})

IssueTypeFieldsSubmitter.displayName = "IssueTypeFieldsSubmitter"
